module.exports = __webpack_public_path__ + "static/media/logo-external.de2ec7d8.png";